import React from 'react';
import { ReactComponent as Icon } from '@weezevent/throne/dist/images/seating/siege-available.svg';
import css from '../Seatmap/seat-map.module.css';
import TitleItem from './TitleItem';

function SeatTitle({ seat, color }) {
    return (
        <>
            <style>{`svg.selected-seat-icon-${seat?.uuid} path {
                fill: ${color} !important;
            }`}</style>

            <span className={css['selected-seats-title']}>
                <span>
                    <Icon className={`${css['selected-seat-icon']} selected-seat-icon-${seat?.uuid}`} />
                </span>
                <TitleItem title={'ticket.attendees.import.errors.details.seat_seat'} value={seat.seat} />
                <li></li>
                <TitleItem title={'ticket.attendees.import.errors.details.seat_row'} value={seat.row} />
                <li></li>
                <TitleItem title={'ticket.attendees.import.errors.details.seat_access'} value={seat.access} />
            </span>
        </>
    );
}

export default SeatTitle;
